import { Link } from "react-router-dom";
import { Button } from "antd";

export default function HostEventCTA() {
  return (
    <section className="hostEventCTASection">
      <div className="container">
        <div className="hostEventCTACard">
          <h2>Host Your Own Event</h2>
          <p>
            Create unforgettable experiences with Pingvite. Build your event page, manage registrations, and start
            selling tickets in minutes.
          </p>
          <Link to="/host-event">
            <Button className="hostEventCTAButton" size="large" type="primary">
              Get Started For Free
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
